function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "D7A2746C-1643-4A3A-86D2-5080872A11B8");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M13.7646104,5.7764 L7.46461043,0.1764 C7.19931043,-0.0588 6.80031043,-0.0588 6.53501043,0.1764 L5.59981043,1.008 L5.59981043,0.7 C5.59981043,0.3136 5.28691043,7.10542736e-15 4.89981043,7.10542736e-15 L2.09981043,7.10542736e-15 C1.71271043,7.10542736e-15 1.39981043,0.3136 1.39981043,0.7 L1.39981043,4.7411 L0.235010426,5.7764 C-0.0540895744,6.034 -0.0799895744,6.4757 0.176910426,6.7655 C0.433110426,7.0539 0.875510426,7.0784 1.16461043,6.8236 L1.39981043,6.6143 L1.39981043,13.3 C1.39981043,13.6864 1.71271043,14 2.09981043,14 L11.8998104,14 C12.2869104,14 12.5998104,13.6864 12.5998104,13.3 L12.5998104,6.6143 L12.8350104,6.8236 C12.9680104,6.9419 13.1346104,7 13.2998104,7 C13.4923104,7 13.6848104,6.9209 13.8227104,6.7655 C14.0796104,6.4757 14.0537104,6.034 13.7646104,5.7764 L13.7646104,5.7764 Z M11.1998104,12.6 L9.79981043,12.6 L9.79981043,9.1 C9.79981043,8.7136 9.48691043,8.4 9.09981043,8.4 L4.89981043,8.4 C4.51271043,8.4 4.19981043,8.7136 4.19981043,9.1 L4.19981043,12.6 L2.79981043,12.6 L2.79981043,5.3697 L6.99981043,1.6366 L11.1998104,5.3697 L11.1998104,12.6 Z M5.59981043,12.6 L8.39981043,12.6 L8.39981043,9.8 L5.59981043,9.8 L5.59981043,12.6 Z M2.79981043,1.4 L4.19981043,1.4 L4.19981043,2.2526 L2.79981043,3.4972 L2.79981043,1.4 Z",
  id: "path-1"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "side-nav/default",
  transform: "translate(-16.000000, -11.000000)"
}, React.createElement("g", {
  id: "icon/dashboard",
  transform: "translate(16.000000, 11.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}), React.createElement("use", {
  fill: "#42526E",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
}))));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.5a48c2d5.svg";
export { ForwardRef as ReactComponent };